import type { ButtonProps } from "antd";

import { useGetNotificationsUnreadCount } from "@/entities/notifications";

import { NotificationsMarkAllButton } from "./notifications-mark-all-button.component";

export const NotificationsMarkAllButtonWrapper = (props: ButtonProps) => {
  const { unreadCount } = useGetNotificationsUnreadCount();

  if (!unreadCount) return;

  return <NotificationsMarkAllButton {...props} />;
};
